import { Icon } from "@qw/ui";

export const ChatEmpty = () => {
  return (
    <section className="flex flex-auto flex-col items-center justify-center p-8 space-y-4">
      <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center text-3xl text-primary">
        <Icon icon="smart_toy" />
      </div>
      <div className="space-y-2">
        <h3 className="font-semibold justify-center">Ask Alby about your documents</h3>
        <p className="text-center text-sm text-muted-foreground">
          Get insights from your insurance documents by asking questions in natural language.
        </p>
      </div>
    </section>
  );
};
